export enum CertificateStatus {
    none,
    started,
    created
}